import AddressService from "./address.service";

let inject = [
    '$scope',
    'AddressService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'SessionService',
    'NgTableParams',
    '$mdToast',
    '$uibModal'
];

class AddressController {

    constructor($scope,
                AddressService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                SessionService,
                NgTableParams,
                $mdToast,
                $uibModal) {

        this.$scope = $scope;
        this.AddressService = AddressService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.NgTableParams = NgTableParams;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.SharedService = SharedService;
        this.newDirection = {};
        this.directions = [];
        this.showError = null;
        this.showSuccess = null;
        this.directionSave = {};
        this.showErrorAlone = null;
        this.locationsByFastSearch = [];
    }

    $onInit() {
        this.initComponents();
    }

    initComponents() {
        let userId = '';
        let centroDeOperaciones = ''
        try {
            userId = this.shCtrl.globals.currentUser.userId;
            centroDeOperaciones = this.shCtrl.globals.currentClient.operatingCenter.id;
        }
        catch (e) {
        }

        this.AddressService.getAllDirections(userId,'',centroDeOperaciones).then(response => {

            if(!response.error){
                this.directions = [];
                angular.forEach(response.data, (value, key) => {
                    value.principal = value.principal === 1;
                    this.directions.push(value);
                });
            }
        });
    }

    selectFavorite() {
        if (!this.newDirection.principal) {
            if (this.newDirection.id && !this.directions.some((val) => {
                return val.principal && val.id !== this.newDirection.id;
            })) {
                this.newDirection.principal = true;
                if(__env.adaptative){
                  this.messageMaterial('Debes tener una dirección como principal');
                }else{
                  this.showError = 'Debes tener una dirección como principal';
                }

                showErrorsDirection();
            }
        } else if (this.directions.length) {
            if (this.directions.some((val) => {
                return val.principal && val.id !== this.newDirection.id;
            })) {
                showConfirmPrincipalDirection();
            }
        }
    }

    cancelChangePrincipalDirection() {
        this.newDirection.principal = false;
    }

    getLocationsByFastSearch() {
        if (!this.newDirection.ciudad) {
            this.newDirection.ciudadId = null;
            this.directionSave = null;
            this.locationsByFastSearch = [];
            return;
        }
        this.newDirection.ciudadId = null;
        this.directionSave = null;
        if (this.newDirection.ciudad.length > 3) {
            this.locationsByFastSearch = [];

            this.AddressService.locationBySearchText(this.newDirection.ciudad).then((response) => {
                this.locationsByFastSearch = response;
            });
        }
    }

    setLocationCity(location) {
        this.newDirection.ciudad = location.cityName + ', ' + location.stateName + ' - ' + location.countryName;
        this.newDirection.ciudadId = location.cityId;
        this.directionSave = location;
        this.locationsByFastSearch = [];
    }

    saveDirection() {

        if (this.directionForm.$valid && this.newDirection.ciudadId) {
            /*if (this.directions.length) {
                if (!this.directions.some((val) => {
                    return val.principal;
                }) && !this.newDirection.principal) {

                    this.showError = 'Debes seleccionar una dirección como principal';
                    this.showErrorsDirection();
                    return;
                }º
            }*/

            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }

            this.newDirection["usuarioId"] = userId;
            if (!this.newDirection.principal) this.newDirection.principal = 0;

            this.AddressService.saveDirection(this.newDirection).then((response) => {
                if (response.error) {
                    this.showErrorAlone = response.message;
                    this.$timeout(() => {
                        this.showErrorAlone = null;
                    }, 1500);

                } else {
                    if(__env.adaptative){
                      this.messageMaterial(response.message);
                    }else{
                      this.showSuccess = response.message;
                    }

                    this.clearForm();
                    this.initComponents();
                    this.$timeout(() => {
                        this.showSuccess = null;
                    }, 1500);
                }

            });
        } else {

            showRegisterErrorsModal();
        }
    }

    editDirection(direction) {


        this.newDirection = angular.copy(direction);
    }

    deleteDirection(direction) {
        if (direction.principal) {
            if(__env.adaptative){
              this.messageMaterial('Debes tener una dirección como principal');
            }else{
              this.showError = 'Debes tener una dirección como principal';
            }

            showErrorsDirection();
        } else {
            this.AddressService.deleteDirection(direction.id).then((response) => {
                if (response.error) {
                    if(__env.adaptative){
                      this.messageMaterial(response.message);
                    }else{
                      this.showErrorAlone = response.message;
                    }

                    this.$timeout(() => {
                        this.showErrorAlone = null;
                    }, 1500);
                } else {
                    if(__env.adaptative){
                      this.messageMaterial('Dirección eliminada correctamente');
                    }else{
                      this.showSuccess = 'Dirección eliminada correctamente';
                    }

                    this.initComponents();
                    this.$timeout(() => {
                        this.showSuccess = null;
                    }, 1500);
                }
            });
        }
    }

    clearError() {
        this.showError = null;
    }

    clearForm() {
        this.newDirection = {};
        this.locationsByFastSearch = [];
        this.directionForm.$setPristine();
    }
    messageMaterial(text){
    var mdToast=this.$mdToast;
    this.$mdToast.show({
      hideDelay   : 7000,
      controller  : function () {
        this.closeToast = function(){
          mdToast.hide();
        }

      },
      controllerAs:'toast',
      template : '<md-toast>\n' +
      '  <span class="md-toast-text">'+ text +'</span>\n' +
      '  <md-button ng-click="toast.closeToast()">\n' +
      '    Cerrar\n' +
      '  </md-button>\n' +
      '</md-toast>'
    });
  }

}

AddressController.$inject = inject;

export default AddressController;




/** WEBPACK FOOTER **
 ** ./www/components/address/address.controller.js
 **/